import Amplitude from 'services/Amplitude';

export default {
  handleSignInClick: (type: string) => (): void => {
    Amplitude.logEvent(null, `Accounts: Signin with ${type} clicked`, {}, true);
  },
};
